 window.WOTCAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration['WOTCServer']);

     self.getWotcStatuses = function (brandId, jobId, applicationsIds, provider) {
         var defer = $q.defer();

         if (!brandId) {
             throw "No brand id";
         }
         var ids = applicationsIds.join(",");

         _protected.request('brands/' + brandId + '/providers/'+provider+'/jobs/'+jobId+'/applications/statuses', 'GET',{ ids: ids })
             .then(function (res) {
                 if (res && res.data) {
                     defer.resolve(res.data.data);
                 } else {
                     defer.reject(res);
                 }
             })
             .catch(function (err) {
                 defer.reject(err);
             });

         return defer.promise;
     };

     self.getWalkinWotcStatus = function(brandId, prospectsIds, provider) {
         var defer = $q.defer();

         if (!brandId) {
             throw "No brand id";
         }
         var ids = prospectsIds.join(",");
         _protected.request('brands/' + brandId + '/providers/'+provider+'/prospects/statuses', 'GET',{ ids: ids })
             .then(function (res) {
                 if (res && res.data) {
                     defer.resolve(res.data.data);
                 } else {
                     defer.reject(res);
                 }
             })
             .catch(function (err) {
                 defer.reject(err);
             });

         return defer.promise;
     };

     self.getApplicationWotcStatus = function(brandId, jobId, applicationId, provider) {
         var defer = $q.defer();

         if (!brandId) {
             throw "No brand id";
         }
         _protected.request('brands/' + brandId + '/providers/'+provider+'/jobs/'+jobId+'/applications/' +applicationId, 'GET')
             .then(function (res) {
                 if (res && res.data) {
                     defer.resolve(res.data.data);
                 } else {
                     defer.reject(res);
                 }
             })
             .catch(function (err) {
                 defer.reject(err);
             });

         return defer.promise;
     };

     self.sendWotcInvitation = function(brandId,payLoad,provider) {

         var defer = $q.defer();
         if (!brandId) {
             throw "No brand id";
         }

         _protected.request('brands/' + brandId + '/providers/'+provider+'/candidate_screenings/send' , 'POST', payLoad)
             .then(function (res) {
                 if (res && res.data) {
                     defer.resolve(res.data.data);

                 } else {
                     defer.reject(res);
                 }
             })
             .catch(function (err) {
                 defer.reject(err);
             });

         return defer.promise;
     };

    self.getBrandWotcSettings = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('candidates/brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

     self.getWotcRestrictionsSettings = async function (brandId) {
         if (!brandId) {
             throw new Error("No brand id");
         }

         try {
             const res = await _protected.request(`brands/${brandId}/settings`, 'GET');
             if (res?.data) {
                 return res.data.data;
             } else {
                 throw new Error('No data in response');
             }
         } catch (err) {
             throw err;
         }
     };

    self.startApplicantScreening = function (brandId, payLoad) {
        var defer = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/candidate_screenings/start', 'POST', payLoad)
            .then(function (res) {
                if (res && res.data) {
                   defer.resolve(res.data.data);

                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.continueApplicantScreening = function (brandId, screeningId, payLoad) {
        var defer = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/candidate_screenings/' + screeningId + '/continue', 'POST', payLoad)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;

    };

    self.getCandidateScreenings = function (payLoad) {
        var defer = $q.defer();
        _protected.request('candidate_screenings', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.prepareCandidateScreenSign = function (brandId, screeningId) {
        var defer = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/candidate_screenings/' + screeningId + '/prepare_sign', 'POST')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.candidateScreenSign = function (brandId, screeningId, payLoad) {
        var defer = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/candidate_screenings/' + screeningId + '/sign', 'POST',payLoad)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.optOutScreening = function (brandId,appId) {
        var defer = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }

        if (!appId) {
            throw "No application id";
        }

        _protected.request('brands/' + brandId + '/candidate_screenings/' + 'opt_out', 'POST',appId)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

     self.getLocationMappings = function (brandId, locationIds) {
         var defer = $q.defer();

         if (!brandId) {
             throw "No brand id";
         }

         if (!locationIds) {
             throw "No location ids";
         }

         var payload = {
             location_ids: locationIds
         };

         _protected.request('/brands/' + brandId + '/locations/mappings', 'GET', payload)
             .then(function (res) {
                 if (res && res.data) {
                     defer.resolve(res.data.data);
                 } else {
                     defer.reject(res);
                 }
             })
             .catch(function (err) {
                 defer.reject(err);
             });

         return defer.promise;
     };

});